import * as React from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ShareIcon from '@mui/icons-material/Share';
import { TooltipMessageStyles } from './Style'
import { QuestionMark } from '@mui/icons-material';
import { useState } from 'react';
import { useCallback } from 'react';

const actions = [
    { icon: <ShareIcon />, name: 'Share' },
];

const TooltipMessage = (props) => {
    const { message } = props
    const [openDial, setOpenDial] = useState(true)

    const handleOpen = useCallback(() => {
        setOpenDial(true)
        setTimeout(() => {
            if (openDial)
                setOpenDial(false)
        }, 5000)
    }, [openDial])

    return (
        <TooltipMessageStyles>
            <SpeedDial
                onMouseOver={handleOpen}
                onClick={() => setOpenDial(!openDial)}
                open={true}
                ariaLabel="SpeedDial basic example"
                icon={
                    <QuestionMark />
                }
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={
                            <div>
                                <div className='tooltip-corner'></div>
                                {message}
                            </div>
                        }
                    />
                ))}
            </SpeedDial>
        </TooltipMessageStyles>
    );
}

export default TooltipMessage